import React, {useRef, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import BiographySlider from "./components/BiographySlider";

/**
 * 아카이브 > 회고록 > 메인
 */
const BiographyMain = () => {
    const navigate = useNavigate();

    const [searchFilter, setSearchFilter] = useState("author"); // 검색 기준
    const term = useRef('');

    // 검색어 지정
    const handleTerm = (e) => {
        term.current = e.target.value;
    }

    // 검색 기능
    const handleSearch = () => {
        if (term.current.length > 0) {
            navigate(`/archive/biography/search?search=${term.current}&filter=${searchFilter}`);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault(); // 폼 제출 방지
            handleSearch();
        }
    };

    return (
        <main id="contents">
            <div className="sub-content">
                <div className="archive-wrap">
                    <div className="cont-top">
                        <div className="w-set">
                            <div className="title-wrap">
                                <h2 className="title batang">회고록</h2>
                                <p className="text">
                                    과거와 현재를 이어주는 회고록을 들여다보며, <br/>
                                    우리네의 삶 속에서 겪었던 다양한 교육적 경험을 확인할 수 있습니다.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="cont-btm">
                        <div className="archive-text-box">
                            <div className="w-set">
                                <div className="text-wrap">
                                    <p><strong>한국근대교육사연구센터는 한국 근대 교육에 대한 깊이 있는 이해를 위해 방대한 회고록 자료를 수집하고, 이를 체계적으로 분석하는 회고록 DB 구축 사업을 진행하고 있습니다.</strong></p>
                                    <p className="text">연구센터의 주요 과제는 회고록에 담긴 학생과 교사 등의 인물들이 경험한 사건과 살아온 이야기를 기록하여, 이를 DB화하는 것입니다. 현재까지 센터가 국공립 도서관 등 여러 곳에서 파악한 회고록의 전체 목록은 3,300권이 넘습니다. 이 회고록에는 학생과 교사들의 학창시절 이야기가 있고, 그들이 살아가는 삶의 흔적들이 담겨 있습니다. 센터는 1960년대부터 2020년대까지 다양한 시대에 걸쳐 회고록을 수집해왔으며, 매년 100권씩 6년동안 총 600권의 교육 경험 정보를 데이터베이스에 입력해왔습니다. 입력한 회고록을 통해 당시 그 학교에서 어떤 입학과 졸업 제도가 있었는지, 시험이나 편입 제도는 어떻게 운영되었는지, 그리고 선생님과 학생, 친구들 사이의 관계가 어떠하였는지 등을 세부적으로 파악할 수 있습니다. 이는 공식적인 기록에서 쉽게 접할 수 없는 개인적인 경험을 통해 학교와 교육 현장의 실제 모습을 드러내는 작업입니다. 회고록이 공식적인 1차 사료는 아니지만, 이러한 작업은 그동안 역사에서 주목받지 못한 개인의 삶을 이해하고, 교육 현장의 여러 모습을 파악하는 데 중요한 역할을 할 수 있습니다. 센터는 회고록을 단순한 개인의 이야기가 아니라 교육사를 연구하는 데 꼭 필요한 자료로 보고 있습니다. 이에 앞으로도 다양한 시대와 사람들의 회고록을 수집하여 데이터베이스를 발전시켜 한국근대교육사의 길잡이 역할을 수행하고자 합니다.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="archive-biography">
                            <div className="w-set">
                                <div className="search-wrap">
                                    <form onSubmit={(e) => e.preventDefault()}>
                                        <div className="search-box">
                                            <div className="select-area">
                                                <select
                                                    value={searchFilter}
                                                    onChange={(e) => setSearchFilter(e.target.value)} // 선택 시 상태 업데이트
                                                >
                                                    <option value="author">저자</option>
                                                    <option value="title">제목</option>
                                                </select>
                                            </div>
                                            <div className="search-area">
                                                <div className="input-wrap">
                                                    <label htmlFor="">
                                                        <input
                                                            type="text"
                                                            name="search"
                                                            placeholder="검색어를 입력해 주세요."
                                                            onChange={handleTerm}
                                                            onKeyDown={handleKeyDown}
                                                        />
                                                    </label>
                                                    <button type="button" className="btn-search" onClick={handleSearch}>
                                                        검색
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <BiographySlider />
                                <div className="btn-wrap type-center">
                                    <Link to={`/archive/biography/search`} className="btn color2">전체 회고록 목록 (연도별)</Link>
                                    <Link to={`/biography_about`} className="btn color3">회고록에 등장하는 교육경험</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default BiographyMain;
